import React, { useEffect, useState } from "react";
import LiveFanImage from "../../../assets/Icon/req.png";
import axios from "axios";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import AllModuleData from "../../../Components/Reuseable/AllModuleData";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const InvitationFan = () => {
  const [event_data, setAllFanActive] = useState([]);
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get("/api/star/fan/group/starlist/status").then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setAllFanActive(res.data.starActive);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title="Invitation Fan Group"
        image={LiveFanImage}
        count={event_data.length}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <AllModuleData
          data={event_data}
          urlLink={`fan-group-invitation/details`}
          fan={"true"}
        />
      )}
    </>
  );
};

export default InvitationFan;
